exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{background-color:#fff}body{margin:0;padding:0;font-family:sans-serif}body div{text-align:center}h1{margin:0}h1,h2{padding:0}h2{margin:50px 0 0}.header{background-color:#add8e6;color:#fff;padding:50px}.header,button{box-shadow:0 1px 6px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.12)}button{display:inline-block;background:rgba(0,0,0,.05);border-radius:3px;border:none;padding:10px 30px;cursor:pointer;font-weight:700;text-transform:uppercase;margin:50px 15px;min-width:115px;transition-duration:.25s}button:hover{box-shadow:0 3px 10px rgba(0,0,0,.16),0 3px 10px rgba(0,0,0,.23)}.count{padding-bottom:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/main.css
// module id = 3
// module chunks = 0